import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
import { GeneralService } from 'src/app/Service/general.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-subscription-plan',
  templateUrl: './subscription-plan.component.html',
  styleUrls: ['./subscription-plan.component.scss']
})
export class SubscriptionPlanComponent implements OnInit {
  planForm: FormGroup;
  Plan: any;
  submitted = false;
  isedit: boolean;
  loading: boolean = false;
  error: any;
  success: string;
  id: any;
  user: any;
  UserId: any;
  planID: any;
  constructor(private router: Router,
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<SubscriptionPlanComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private gs: GeneralService,
  ) { 
    let a = this.router.getCurrentNavigation().extras
    if(a){
      if(a.state){
        this.UserId = a.state.UserId
        this.planID = a.state.PlanId
        localStorage.setItem('UserId',this.UserId)
        localStorage.setItem('PlanId',this.planID)
      }
    }
  }

  ngOnInit() {
    if(this.data.PlanId){
      this.getSubscriptionPlan(this.data.PlanId);
      console.log("Plan ID",this.data.PlanId)
    }
    this.getusersbyid(this.data.UserId);
    this.planForm = this.fb.group({
      max_value: new FormControl('', [Validators.required, Validators.pattern('^[0-9]+$')]),
      max_area_sub: new FormControl('', [Validators.required, Validators.pattern('^[0-9]+$')]),
      max_EPP: new FormControl('',),
      max_auction: new FormControl(''),
      max_tp_village: new FormControl(''),
      mobileNumbers: new FormControl('', [Validators.required, Validators.pattern('^[0-9]+$')]),
      ultimatePP: new FormControl(''),
      todaysNotice: new FormControl(''),
      findLawyer: new FormControl(''),
      findBroker: new FormControl(''),
      jantriRates: new FormControl(''),
      jaminBuySell: new FormControl(''),
      max_titlesearch: new FormControl(''),
      profitableInvestment: new FormControl(''),
      group: new FormControl(''),
      id: new FormControl(''),
      is_active: new FormControl(''),
      titleSearch: new FormControl(''),
      price: new FormControl('')
    });
    this.viewOnlyMode();
  }
  getSubscriptionPlan(data) {
    this.gs.getPlanDetails(data).subscribe((Response: any) => {
        this.Plan = Response.data;
        this.planForm.patchValue(this.Plan[0]);
      },(error) => {                              //Error callback
        this.loading = false;
        Swal.fire({
          title: error.status,
          text: "Internal Server Error",
          type: "error",
        });
        //throw error;   //You can also throw the error to a global error handler
      });
  }
  viewOnlyMode() {
    this.isedit = false;
    if(this.Plan != undefined) {
      this.planForm.patchValue(this.Plan[0]);
    }
    this.planForm.controls.max_value.disable();
    this.planForm.controls.max_area_sub.disable();
    this.planForm.controls.max_EPP.disable();
    this.planForm.controls.max_auction.disable();
    this.planForm.controls.max_tp_village.disable();
    this.planForm.controls.mobileNumbers.disable();
    this.planForm.controls.ultimatePP.disable();
    this.planForm.controls.todaysNotice.disable();
    this.planForm.controls.findLawyer.disable();
    this.planForm.controls.findBroker.disable();
    this.planForm.controls.jantriRates.disable();
    this.planForm.controls.jaminBuySell.disable();
    this.planForm.controls.titleSearch.disable();
    this.planForm.controls.profitableInvestment.disable();
  }
  EditMode() { 
    if(this.data.PlanId === "1"){
      Swal.fire({
        title:"Can't Update Subscription plan" ,
        text: "This subscrition plan is default Please change the subscription plan to edit.",
        type: "info",
      });
    }
    else{
      this.isedit = true;
      this.planForm.controls.max_value.enable();
      this.planForm.controls.max_area_sub.enable();
      this.planForm.controls.max_EPP.enable();
      this.planForm.controls.max_auction.enable();
      this.planForm.controls.max_tp_village.enable();
      this.planForm.controls.mobileNumbers.enable();
      this.planForm.controls.ultimatePP.enable();
      this.planForm.controls.todaysNotice.enable();
      this.planForm.controls.findLawyer.enable();
      this.planForm.controls.findBroker.enable();
      this.planForm.controls.jantriRates.enable();
      this.planForm.controls.jaminBuySell.enable();
      this.planForm.controls.titleSearch.enable();
      this.planForm.controls.profitableInvestment.enable();
    }
  }
  onConfirmClick(): void {
    this.dialogRef.close(true);
  }
  get f() { return this.planForm.controls; }
  onSubmit() {
    this.submitted = true;
    if (this.planForm.invalid) {
      return;
    }
    this.loading = true;
    this.gs.updateSubscriptionPlan(this.data.PlanId, this.planForm.value).subscribe(
      data => {
          if(data.errorMessage) {
            this.error = data.errorMessage;
            this.loading = false;
            return;

          }
          this.error = undefined;
          Swal.fire({
            position: 'top-end',
            type: 'success',
            title: data.message,
            showConfirmButton: false,
            timer: 1500
          });
          this.loading = false;
          this.onConfirmClick();
      },(error) => {                              //Error callback
        this.loading = false;
        Swal.fire({
          title: error.status,
          text: "Internal Server Error",
          type: "error",
        });
        //throw error;   //You can also throw the error to a global error handler
      });
  }
  getusersbyid(id) {
    this.loading = true;
    this.gs.getusersbyid(id)
    .subscribe(
      (res: any) => {
        this.loading = false;
        this.user = res.data[0];
        this.user.mobileno = this.user.mobileno.split(',');
        this.user.email = this.user.email.split(',');
      },(error) => {                              //Error callback
        this.loading = false;
        Swal.fire({
          title: error.status,
          text: "Internal Server Error",
          type: "error",
        });
        //throw error;   //You can also throw the error to a global error handler
      });
  }
}
